import { supabase } from '../lib/supabase';
import type { PerguntaConselho, RespostasConselho } from '@ponti/shared';

export interface Vaga {
  id: string; titulo: string; descricao: string | null; total_vagas: number;
  aberta: boolean; encerra_em: string | null; perguntas: PerguntaConselho[];
}
export interface MinhaCandidatura { id: string; vaga_id: string; status: 'pendente' | 'aprovada' | 'reprovada'; }
export interface Aviso { id: string; titulo: string; conteudo: string; criado_em: string; criado_por_nome: string | null; }
export interface ConselheiroPublico { nome: string; vaga: string | null; data_posse: string; mandato_fim: string | null; }
export interface AndamentoVaga { vaga: string; total_vagas: number; aberta: boolean; encerra_em: string | null; candidatos: number; aprovados: number; empossados: number; }

const COLS_VAGA = 'id, titulo, descricao, total_vagas, aberta, encerra_em, perguntas';

export const conselhoService = {
  /** Vagas abertas — leitura liberada para anon (transparência, Lei 13.460). */
  async listarVagasAbertas(estabId: string): Promise<Vaga[]> {
    const { data, error } = await supabase.from('conselho_vagas').select(COLS_VAGA)
      .eq('estabelecimento_id', estabId).eq('aberta', true).order('criado_em', { ascending: false });
    if (error) throw error; return (data ?? []) as Vaga[];
  },
  async buscarVaga(id: string): Promise<Vaga | null> {
    const { data, error } = await supabase.from('conselho_vagas').select(COLS_VAGA).eq('id', id).eq('aberta', true).maybeSingle();
    if (error) throw error; return (data ?? null) as Vaga | null;
  },
  async minhasCandidaturas(cidadaoId: string): Promise<MinhaCandidatura[]> {
    const { data } = await supabase.from('conselho_candidaturas').select('id, vaga_id, status').eq('cidadao_id', cidadaoId);
    return (data ?? []) as MinhaCandidatura[];
  },
  async candidatar(estabId: string, vagaId: string, cidadaoId: string, cidadaoNome: string, justificativa: string, respostas: RespostasConselho): Promise<void> {
    const { error } = await supabase.from('conselho_candidaturas').insert({
      estabelecimento_id: estabId, vaga_id: vagaId, cidadao_id: cidadaoId, cidadao_nome: cidadaoNome, justificativa, respostas,
    });
    if (error) throw error;
  },
  /** Conselheiros empossados (transparência pública — RPC). */
  async listarConselheiros(estabId: string): Promise<ConselheiroPublico[]> {
    const { data, error } = await supabase.rpc('conselho_membros_publico', { p_estabelecimento_id: estabId });
    if (error) throw error;
    return (data ?? []) as ConselheiroPublico[];
  },

  /** Andamento do processo de escolha por vaga (transparência pública — RPC). */
  async andamento(estabId: string): Promise<AndamentoVaga[]> {
    const { data, error } = await supabase.rpc('conselho_andamento', { p_estabelecimento_id: estabId });
    if (error) throw error;
    return (data ?? []) as AndamentoVaga[];
  },

  async listarAvisos(): Promise<Aviso[]> {
    // RLS so retorna se o cidadao for membro aprovado (ou admin).
    const { data } = await supabase.from('conselho_avisos').select('id, titulo, conteudo, criado_em, criado_por_nome').order('criado_em', { ascending: false });
    return (data ?? []) as Aviso[];
  },
};
